import { createContext, useContext, useState, useEffect } from "react";
import axios from "axios";

const AuthContext = createContext(null);
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function AuthProvider({ children }) {
  const [admin, setAdmin] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("piikk_admin_token");
    if (!token) { setLoading(false); return; }
    axios.get(`${API}/auth/me`, { headers: { Authorization: `Bearer ${token}` } })
      .then(res => setAdmin({ ...res.data, token }))
      .catch(() => localStorage.removeItem("piikk_admin_token"))
      .finally(() => setLoading(false));
  }, []);

  const login = async (email, password) => {
    const res = await axios.post(`${API}/auth/login`, { email, password });
    localStorage.setItem("piikk_admin_token", res.data.access_token);
    setAdmin({ email: res.data.email, role: res.data.role, token: res.data.access_token });
    return res.data;
  };

  const logout = () => {
    localStorage.removeItem("piikk_admin_token");
    setAdmin(null);
  };

  const authHeader = () => ({
    headers: { Authorization: `Bearer ${localStorage.getItem("piikk_admin_token")}` }
  });

  return (
    <AuthContext.Provider value={{ admin, loading, login, logout, authHeader }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
